import { formatDollarsLong } from './formatDollarsLong';
import { getNumberFormat } from './getNumberFormat';

const largeFormatter = getNumberFormat('en', {
    // can't use 'currency' option here because it doesn't allow maximumFractionDigits below 2
    notation: 'compact',
    compactDisplay: 'short',
    maximumFractionDigits: 1,
});

/**
 * Formats a number to have at least two decimal places of precision for numbers less than 1000. For
 * numbers of 1000 or greater, a roman numeral (such as K for "thousand") is appended and up to one
 * decimal place is used.
 *
 * Examples:
 *      formatDollarsMedium(0.01) =>  $0.01
 *      formatDollarsMedium(1.0) =>  $1.00
 *      formatDollarsMedium(1.011) =>  $1.011
 *      formatDollarsMedium(1011) =>  $1K
 * @param param
 */
export const formatDollarsMedium = (value: Maybe<number>): string => {
    if (value === null) {
        return '$0.00';
    }

    if (value < 1000) {
        return formatDollarsLong(value);
    }

    return `$${largeFormatter.format(value)}`;
};
